import s from './Footer.module.scss'
export const Footer = () => {
    return (
        <div className={s.Footer}>
            <h1>Все права защищены! ©HAPPY SHOP 2024</h1>
        </div>
    )
}